import { createApp } from 'vue'
import { createPinia } from 'pinia'
import cleaveDirective from './directives/cleaveDirective'

import '@/assets/sass/main.scss'
import 'vue-toastification/dist/index.css'

import * as Sentry from '@sentry/vue'
import App from './App.vue'
import router from './router'
import Toast, { useToast } from 'vue-toastification'
import Helpers from '@/helpers'

const app = createApp(App)

app.use(Toast)
app.use(createPinia())
app.use(router)
app.directive('cleave', cleaveDirective)
app.mount('#app')

Sentry.init({
  app,
  dsn: import.meta.env.VITE_SENTRY_DNS,
  environment: import.meta.env.VITE_SENTRY_ENVIRONMENT,
  integrations: [
    new Sentry.BrowserTracing({
      routingInstrumentation: Sentry.vueRouterInstrumentation(router),
    }),
  ],
  beforeSend(event, hint) {
    const error = hint?.originalException

    if (error && Helpers.isExpectedError(error)) {
      useToast().error('Ocorreu um erro ao processar sua solicitação. Tente novamente mais tarde.')
      return null
    }

    return event
  },

  // Set tracesSampleRate to 1.0 to capture 100%
  // of transactions for performance monitoring.
  // We recommend adjusting this value in production
  tracesSampleRate: 0.0,

  // Set `tracePropagationTargets` to control for which URLs distributed tracing should be enabled
  tracePropagationTargets: [import.meta.env.VITE_BASE_URL],
})
